'use client';

import { tamaguiConfig, TamaguiProvider, type TamaguiProviderProps } from '@cxnpl/ui';
import type { ReactNode } from 'react';
// eslint-disable-next-line no-restricted-imports -- JULIAN TODO: come back and suss
import { useServerInsertedHTML } from 'next/navigation';
import { ThemeSwitcherProvider } from '../ThemeSwitcher';

export interface UIProviderProps extends Partial<TamaguiProviderProps> {
  children: ReactNode;
}

export function UIProvider({ config, defaultTheme, children, ...props }: UIProviderProps) {
  useServerInsertedHTML(() => {
    // this will return the entire CSS every time. getNewCSS() doesn't work reliably
    return <style dangerouslySetInnerHTML={{ __html: tamaguiConfig.getCSS() }} />;
  });
  return (
    <TamaguiProvider
      config={config ?? tamaguiConfig}
      defaultTheme={defaultTheme ?? 'dark'} // TODO system / local user setting
      {...props}
    >
      <ThemeSwitcherProvider>{children}</ThemeSwitcherProvider>
    </TamaguiProvider>
  );
}
